import type { Profile } from '@ficpod/core-types'
import { getSupabase } from '../auth'

export async function getProfile(userId: string) {
  const supabase = getSupabase()
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single()

  if (error) throw error
  return data as Profile
}

export async function adminCreateAuthor(
  targetUserId: string,
  penName?: string,
  authorBio?: string
) {
  const supabase = getSupabase()
  const { data, error } = await supabase.rpc('admin_create_author', {
    target_user_id: targetUserId,
    pen_name: penName || null,
    author_bio: authorBio || null
  })

  if (error) throw error
  return data
}

export async function adminCreateUserWithAuthor(
  email: string,
  password: string,
  username: string,
  displayName?: string,
  penName?: string,
  authorBio?: string
) {
  const supabase = getSupabase()
  const { data, error } = await supabase.rpc('admin_create_user_with_author', {
    p_email: email,
    p_password: password,
    p_username: username,
    p_display_name: displayName || null,
    p_pen_name: penName || null,
    p_author_bio: authorBio || null
  })

  if (error) throw error
  return data as string
}

export async function updateProfile(updates: Partial<Profile>) {
  const supabase = getSupabase()
  const { data: { user } } = await supabase.auth.getUser()

  if (!user) {
    throw new Error('Not authenticated')
  }

  const { data, error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', user.id)
    .select()
    .single()

  if (error) throw error
  return data as Profile
}
